module.exports = __webpack_public_path__ + "static/img/13044C_1_2_R_20210913_LC.946374f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13044C_1_2_R_20210913_LC.png
// module id = 3cub
// module chunks = 0